import { QueryClientProvider } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet, useRouterState } from '@tanstack/react-router'
import { ToastViewport } from '../components/ui'
import { queryClient } from '../lib/query-client'

export type RouterContext = {
  queryClient: typeof queryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const isAuthRoute =
    pathname === '/signup' ||
    pathname === '/login' ||
    pathname === '/verify-email' ||
    pathname === '/forgot-password' ||
    pathname === '/reset-password'

  return (
    <QueryClientProvider client={queryClient}>
      <div className={isAuthRoute ? 'min-h-screen' : 'min-h-screen bg-white'}>
        <Outlet />
      </div>
      <ToastViewport />
    </QueryClientProvider>
  )
}
